import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { statusAsesoria } from '../../actions/asesorias';

const FinalizarAsesoria = ({ asesoria, reestablecerAsesoria }) => {

    const dispatch = useDispatch();

    const [finalizarModal, setFinalizarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(statusAsesoria(asesoria?.id, 1, asesoria?.detalles));
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerAsesoria(null);
            setFinalizarModal(false);
        }
    }

    useEffect(() => {
        if(asesoria != null){
            setFinalizarModal(true);
        }
    }, [asesoria]);

    return (
        <Modal show={finalizarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Finalizar asesoría</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas finalizar la asesoría? Esta acción no se puede deshacer.</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={statusProcesar}><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sí</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Sí</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default FinalizarAsesoria;
